import { configureStore } from '@reduxjs/toolkit'
import pageNameReducer from './reducers/pageNameSlice'
import { NotificationReducer } from './reducers/notification'
import { apiSlice } from './api/apiSlice'
import pageHeaderReducer from './reducers/pageHeaderSlice'
import { ProjectDistributionDateRangeReducer } from './reducers/dateRangeDistributionSlice'
import leaderSlice from './reducers/leaderSlice'
import currentUserReducer from './reducers/currentUserSlice'
import breadcrumbsSlice from './reducers/breadcrumbsSlice'
import { monthPickerReducer } from './reducers/monthPickerSlice'
import sidebarReducer from './reducers/sidebarSlice'
import currentModeReducer from './reducers/darkModeSlice'
import settingsReducer from './reducers/settingsSlice'
import loggingOutWarningReducer from './reducers/LoggingOutWarningSlice'

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    currentUser: currentUserReducer,
    sidebar: sidebarReducer,
    pageHeader: pageHeaderReducer,
    pageName: pageNameReducer,
    monthPicker: monthPickerReducer,
    notification: NotificationReducer,
    projectDistributionDateRange: ProjectDistributionDateRangeReducer,
    leaderId: leaderSlice,
    breadcrumbs: breadcrumbsSlice,
    darkMode: currentModeReducer,
    settings: settingsReducer,
    loggingOutWarning: loggingOutWarningReducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(apiSlice.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
